import { z } from 'zod';

export const AggWeatherSchema = z.object({
    timestamp: z.string(),
    illuminanceAvg: z.number().nullable(),
    uvIndexMax: z.number().nullable(),
    temperatureMin: z.number().nullable(),
    temperatureMax: z.number().nullable(),
    temperatureAvg: z.number().nullable(),
    humidityAvg: z.number().nullable(),
    rainfallSum: z.number().nullable(),
    absPressureAvg: z.number().nullable(),
    windSpeedAvg: z.number().nullable(),
    gustSpeedMax: z.number().nullable(),
    windDirectionAvg: z.number().nullable(),
});
